import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    template: `
        <div mat-dialog-title>{{title}}</div>
        <div mat-dialog-content>
            <div *ngIf="content" [innerHtml]="content"></div>
        </div>
        <div mat-dialog-actions>
            <button mat-raised-button  color="primary"  [mat-dialog-close]="true">{{actionLabel}}</button>
            <button *ngIf="!hideCancel" mat-button mat-dialog-close>Cancel</button>
        </div>
    `
})
export class ConfirmationDialogComponent implements OnInit {
    title: string;
    content: string;
    actionLabel: string;
    hideCancel: boolean;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit() {
        this.title = this.data.title || 'Continue?';
        this.content = this.data.content;
        this.actionLabel = this.data.actionLabel || 'OK';
        this.hideCancel = !!this.data.hideCancel;
    }
};